import ParseHtml from './ParseHtml';

export default ParseHtml;
